import React from 'react';
import {Button, Typography} from "@mui/material";

import {buttonStyles, DownloadButtonProps} from './downloadButton-helpers';
import {downloadFile} from "../../pages/common.helper";

export const DownloadButton = (props: DownloadButtonProps) => {
    const {buttonText, buttonIcon, fileUrl, buttonType} = props;
    const handleOpenDocument = (url: string) => downloadFile(url);

    return (
        <Button sx={buttonStyles.button} onClick={() => handleOpenDocument(fileUrl)}>
            <img src={buttonIcon} alt={buttonType + " Icon"} style={buttonStyles.downloadIcon} />
            <Typography sx={buttonStyles.downloadText}>
                {buttonText}
            </Typography>
        </Button>
    )
};

